import InlineSVG from "react-inlinesvg";
import { sendAppEvent } from "../../../Utils.js";
import { ResourcesCardContainer } from "./styles.js";

export default function ResourcesCard({ onClose }) {
  return (
    <ResourcesCardContainer>
      <button
        className="close-button"
        onClick={onClose}
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
      >
        <InlineSVG
          src="/assets/close.svg"
          className="close"
        />
      </button>
      <div className="resources-title">Writer-made resources</div>
      <div className="resources-container">
        <a
          className="resource"
          target="_blank"
          href="https://lu.ma/sudowrite/?utm_source=EDU_cards"
          onClick={(e) => {
            e.preventDefault();
            sendAppEvent("Click Live Classes", { source: "EDU_cards" });
            window.open("https://lu.ma/sudowrite/?utm_source=EDU_cards", "_blank");
          }}
        >
          Browse Live Classes
        </a>
        <a
          className="resource"
          target="_blank"
          href="https://discord.gg/z9b3N4gyUM"
          onClick={(e) => {
            e.preventDefault();
            sendAppEvent("Click Join Discord", { source: "EDU_cards" });
            window.open("https://discord.gg/z9b3N4gyUM", "_blank");
          }}
        >
          Join Our Community
        </a>
        <a
          className="resource"
          target="_blank"
          href="https://www.youtube.com/@sudowrite4400"
          onClick={(e) => {
            e.preventDefault();
            sendAppEvent("Click Youtube", { source: "EDU_cards" });
            window.open("https://www.youtube.com/@sudowrite4400", "_blank");
          }}
        >
          Learn On YouTube
        </a>
        <a
          className="resource"
          target="_blank"
          href="https://docs.sudowrite.com/getting-started/dQph1snuwbfMWG9wRjsNug/quick-start/2A4FjtiocrtxHPUyz6WZgR"
          onClick={(e) => {
            e.preventDefault();
            sendAppEvent("Click Help Guide", { source: "EDU_cards" });
            window.open("https://docs.sudowrite.com/getting-started/dQph1snuwbfMWG9wRjsNug/quick-start/2A4FjtiocrtxHPUyz6WZgR", "_blank");
          }}
        >
          Read The Docs
        </a>
      </div>
    </ResourcesCardContainer>
  );
}
